export default [
    {
        name:'info',
        path:'info',
        meta: { title: '我的信息' },
        component: ()=>import('@/pages/info/index.vue')
    }
]